import React, { useContext } from 'react';

import { RichText } from 'src/components/RichText/RichText';
import { HomeContext } from 'src/components/Home/HomeProvider';

export function HomeContent() {
    const { content } = useContext(HomeContext);

    if (!content) {
        return null;
    }

    return <RichText content={content} />;
}
